<div
  class="card-header app-text-white app-bg-dark d-flex justify-content-between align-items-center"
  [@expandCollapseHeader]="expanded ? 'expanded' : 'collapsed'"
  role="button"
  (click)="toggleAccordion()"
>
  <div class="d-flex align-items-center">
    <img *ngIf="team.lead.photoUrl" [src]="team.lead.photoUrl" class="img-thumbnail rounded-circle mr-3"
          style="height: 50px; width: 50px; object-fit: cover" (error)="team.lead.photoUrl = ''"/>
    <img *ngIf="!team.lead.photoUrl" appDealerIcon class="img-thumbnail rounded-circle mr-3"
          style="height: 50px; width: 50px; object-fit: cover"/>
    <span>{{ team.lead.firstName + ' ' + team.lead.lastName }}</span>
  </div>

  <div class="btn-group-horizontal ml-3 float-end">
    <button class="btn btn-sm app-btn-success" type="button" (click)="edit.emit(team)">
      Edit
    </button>
    <button class="btn btn-sm app-btn-neutral" type="button" (click)="delete.emit(team)">
      Delete
    </button>
  </div>
</div>
<div [@expandCollapse]="expanded ? 'expanded' : 'collapsed'" class="d-flex align-items-start justify-content-between">
  <div class="team-spacer"></div>
  <div class="d-flex flex-grow-1 flex-column align-items-start justify-content-between mb-1">
    <ng-container *ngFor="let user of team.members">
      <app-user-card [user]="user" [allowEdit]="false" [allowDelete]="false" class="px-1 pt-1 w-100"></app-user-card>
    </ng-container>
  </div>
</div>